import { UiSprite, UiSpriteId } from '@app/components/simple/ui-sprite';
import styles from './styles.scss';

export const Loader = () =>
    UiSprite({ className: styles.loader, svgId: UiSpriteId.Loader });
